// @flow

import React from 'react';
import { Icon } from '@shopify/polaris';
import { compare } from 'compare-versions';
import {
  HeaderMajor,
  // PriceLookupMinor,
  SectionMajor,
  ListMajor,
  HorizontalDotsMinor,
  ImageMajor,
  TextBlockMajor,
  // SearchMinor,
  TextAlignmentCenterMajor,
  TextAlignmentLeftMajor,
  TextAlignmentRightMajor,
  CheckoutMajor,
  // EmbedMinor,
  CollectionsMajor
} from '@shopify/polaris-icons';
import QuickView from 'src/assets/images/common/quick-view.svg?react';
import TopArea from 'src/assets/images/common/top.svg?react';
import MiddleArea from 'src/assets/images/common/middle.svg?react';
import BottomArea from 'src/assets/images/common/bottom.svg?react';
import LeftAlignment from 'src/assets/images/common/left.svg?react';
import RightAlignment from 'src/assets/images/common/right.svg?react';
import Bold from 'src/assets/images/styles/bold.svg?react';
import Italic from 'src/assets/images/styles/italic.svg?react';
import Underline from 'src/assets/images/styles/underline.svg?react';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import TopLeftAlignment from 'src/assets/images/common/top-left.svg?react';
import BottomRightAlignment from 'src/assets/images/common/bottom-right.svg?react';
import BottomCenterAlignment from 'src/assets/images/common/bottom-center.svg?react';
import BottomLeftAlignment from 'src/assets/images/common/bottom-left.svg?react';
import TopRightAlignment from 'src/assets/images/common/top-right.svg?react';
import MiddleLeftAlignment from 'src/assets/images/common/middle-left.svg?react';
import CentralAlignment from 'src/assets/images/common/central.svg?react';
import MiddleRightAlignment from 'src/assets/images/common/middle-right.svg?react';
import TopCenterAlignment from 'src/assets/images/common/top-center.svg?react';
import IconRectangle from 'src/assets/images/shopify-integration-settings/rectangle.svg?react';
import IconRoundedRectangle from 'src/assets/images/shopify-integration-settings/rounded-rectangle.svg?react';
import IconCapsule from 'src/assets/images/shopify-integration-settings/capsule.svg?react';
import IconCircle from 'src/assets/images/shopify-integration-settings/circle.svg?react';
import IconSquare from 'src/assets/images/shopify-integration-settings/square.svg?react';
import IconRoundedSquare from 'src/assets/images/shopify-integration-settings/rounded-square.svg?react';
import IconButtonRectangle from 'src/assets/images/shopify-integration-settings/btn-rectangle.svg?react';
import IconButtonRoundedRectangle from 'src/assets/images/shopify-integration-settings/btn-rounded-rectangle.svg?react';
import IconButtonCapsule from 'src/assets/images/shopify-integration-settings/btn-capsule.svg?react';

import { VISIBLE_TEMPLATE_SETTING_ELEMENT } from 'src/constants/shopify-integration';

import {
  PRODUCT_IMAGE_ELEMENTS_OPTIONS,
  PRODUCT_INFORMATION_ELEMENTS,
  COLLECTION_HEADER_ELEMENTS,
  TOOLBAR_ELEMENTS,
  LABEL_SHAPE_VALUE,
  SHAPE_VALUE,
  BUTTON_SHAPE_VALUE,
  SUB_LAYOUT_VALUE
} from 'src/constants/theme-settings';
import { THEME_NAME } from './theme-settings';

export const MENU_ID = {
  COLLECTION_HEADER: 'collectionHeader_setting',
  IN_COLLECTION_SEARCH: 'inCollectionSearch_setting',
  SEARCH_HEADER: 'searchHeader_setting',
  SEARCH_RESULT: 'searchResult_setting',
  TOOLBAR: 'toolbar_setting',
  PRODUCT_LIST: 'productList_setting',
  PAGINATION: 'pagination_setting',
  PRODUCT_ITEM: 'productItem_setting',
  PRODUCT_IMAGE: 'productImage_setting',
  PRODUCT_IMAGE_TOP: 'productImageTop_setting',
  PRODUCT_IMAGE_MIDDLE: 'productImageMiddle_setting',
  PRODUCT_IMAGE_BOTTOM: 'productImageBottom_setting',
  PRODUCT_INFORMATION: 'productInformation_setting',
  QUICK_VIEW: 'quickView_setting',
  AJAX_CART: 'cart_setting',
  CUSTOM_CSS: 'customCss_setting',
  PRODUCT_LABEL: 'productLabel',
  SWATCHES: 'swatches'
};

export const MENU_SETTING_COLLECTION = [
  {
    id: MENU_ID.COLLECTION_HEADER,
    title: 'AdminHTML.ThemeSetting.Setting.collection_CollectionHeader',
    icon: <Icon source={HeaderMajor} color="base" />,
    children: [],
    isCollapsible: true,
    isAddable: true,
    isBorder: false,
    elements: COLLECTION_HEADER_ELEMENTS,
    isAllowHide: true,
    isHidden: false,
    notDragDrop: true
  }
  // {
  //   id: MENU_ID.IN_COLLECTION_SEARCH,
  //   title: 'AdminHTML.ThemeSetting.Setting.collection_InCollectionSearch',
  //   icon: <Icon source={SearchMinor} color="base" />,
  //   children: [],
  //   isCollapsible: false,
  //   isAddable: false,
  //   isBorder: true,
  //   isAllowHide: true,
  //   isHidden: false
  // }
];

export const MENU_SETTING_SEARCH = [
  {
    id: MENU_ID.SEARCH_HEADER,
    title: 'AdminHTML.ThemeSetting.Setting.search_SearchHeader',
    icon: <Icon source={HeaderMajor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: false,
    isAllowHide: false,
    isHidden: false,
    notDragDrop: true
  }
  // {
  //   id: MENU_ID.SEARCH_RESULT,
  //   title: 'AdminHTML.ThemeSetting.Setting.search_SearchResult',
  //   icon: <Icon source={PriceLookupMinor} color="base" />,
  //   children: [],
  //   isCollapsible: false,
  //   isAddable: false,
  //   isBorder: true,
  //   isAllowHide: true,
  //   isHidden: false
  // }
];

export const MENU_SETTING_COMMON = [
  {
    id: MENU_ID.TOOLBAR,
    title: 'AdminHTML.ThemeSetting.Setting.general_Toolbar',
    icon: <Icon source={SectionMajor} color="base" />,
    children: [],
    isCollapsible: true,
    isAddable: true,
    isBorder: false,
    elements: TOOLBAR_ELEMENTS
  },
  {
    id: MENU_ID.PRODUCT_LIST,
    title: 'AdminHTML.ThemeSetting.Setting.general_ListOfProduct',
    icon: <Icon source={ListMajor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: false
  },
  {
    id: MENU_ID.PAGINATION,
    title: 'AdminHTML.ThemeSetting.Setting.general_Pagination',
    icon: <Icon source={HorizontalDotsMinor} color="base" />,
    children: [],
    isCollapsible: false,
    isAddable: false,
    isBorder: true
  },
  {
    id: MENU_ID.PRODUCT_ITEM,
    title: 'AdminHTML.ThemeSetting.Setting.productItem',
    isCollapsible: true,
    isBorder: true,
    icon: <Icon source={CollectionsMajor} color="base" />,
    subMenu: [
      {
        id: MENU_ID.PRODUCT_IMAGE,
        title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage',
        icon: <Icon source={ImageMajor} color="base" />,
        children: [
          {
            id: MENU_ID.PRODUCT_IMAGE_TOP,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_TopArea',
            icon: (
              <span className="Polaris-Icon">
                <TopArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          },
          {
            id: MENU_ID.PRODUCT_IMAGE_MIDDLE,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_MiddleArea',
            icon: (
              <span className="Polaris-Icon">
                <MiddleArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          },
          {
            id: MENU_ID.PRODUCT_IMAGE_BOTTOM,
            title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductImage_BottomArea',
            icon: (
              <span className="Polaris-Icon">
                <BottomArea className="Polaris-Icon__Svg" />
              </span>
            ),
            children: [],
            isCollapsible: false,
            isAddable: true,
            isBorder: false
          }
        ],
        isCollapsible: true,
        isAddable: false,
        isBorder: false,
        isHasAreaChildren: true,
        elements: PRODUCT_IMAGE_ELEMENTS_OPTIONS
      },
      {
        id: MENU_ID.PRODUCT_INFORMATION,
        title: 'AdminHTML.ThemeSetting.Setting.productItem_ProductInformation',
        icon: <Icon source={TextBlockMajor} color="base" />,
        children: [],
        isCollapsible: true,
        isAddable: true,
        isBorder: true,
        elements: PRODUCT_INFORMATION_ELEMENTS
      }
    ]
  },
  {
    id: MENU_ID.QUICK_VIEW,
    title: 'AdminHTML.ThemeSetting.Setting.quickView',
    children: [],
    isBorder: true,
    icon: (
      <span className="Polaris-Icon">
        <QuickView className="Polaris-Icon__Svg" />
      </span>
    )
  },
  {
    id: MENU_ID.AJAX_CART,
    title: 'AdminHTML.ThemeSetting.Setting.cartSetting',
    children: [],
    isBorder: true,
    icon: <Icon source={CheckoutMajor} color="base" />
  }
  // {
  //   id: MENU_ID.CUSTOM_CSS,
  //   title: 'AdminHTML.ThemeSetting.Setting.customCss',
  //   children: [],
  //   isBorder: true,
  //   icon: <Icon source={EmbedMinor} color="base" />
  // }
];

export const ALIGNMENT_VALUE = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const PRODUCT_INFORMATION_ALIGNMENT_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];
export const PRODUCT_INFORMATION_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const SWATCH_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const SWATCH_SHAPE_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <IconSquare className="Polaris-Icon__Svg" />
      </span>
    ),
    value: SHAPE_VALUE.SQUARE
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: SHAPE_VALUE.CIRCLE
  }
];

export const LABEL_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const AJAX_CART_DISPLAY_TYPES = [
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item1',
    value: 'side',
    tooltipImage: getAssetURL(ADMIN_APP_ASSET_PATHS?.quickViewCart?.tooltip?.cartDisplaySidecart)
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item2',
    value: 'popup',
    tooltipImage: getAssetURL(ADMIN_APP_ASSET_PATHS?.quickViewCart?.tooltip?.cartDisplayPopupcart)
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item3',
    value: 'none',
    tooltipText: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item3_Tooltip'
  }
];

export const AJAX_CART_DISPLAY_TYPES_V2 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item1',
    value: 'side',
    tooltipImage: getAssetURL(ADMIN_APP_ASSET_PATHS?.quickViewCart?.tooltip?.cartDisplaySidecart)
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Item2',
    value: 'popup',
    tooltipImage: getAssetURL(ADMIN_APP_ASSET_PATHS?.quickViewCart?.tooltip?.cartDisplayPopupcart)
  }
];

export const FONT_STYLE_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <Bold className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'bold'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <Italic className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'italic'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <Underline className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'underline'
  }
];

export const PRODUCT_RATING_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const TEXT_ALIGNMENT_OPTIONS = [
  {
    label: <Icon source={TextAlignmentLeftMajor} color="base" />,
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: <Icon source={TextAlignmentCenterMajor} color="base" />,
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: <Icon source={TextAlignmentRightMajor} color="base" />,
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const POSITION_VALUE = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  MIDDLE_LEFT: 'middle-left',
  MIDDLE_CENTER: 'middle-center',
  MIDDLE_RIGHT: 'middle-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right'
};
export const POSITION_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <TopLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <TopCenterAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <TopRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.TOP_RIGHT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.MIDDLE_RIGHT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_LEFT
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomCenterAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_CENTER
  },
  {
    label: (
      <span className="Polaris-Icon">
        <BottomRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: POSITION_VALUE.BOTTOM_RIGHT
  }
];

export const BUTTON_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const BUTTON_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',

    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const BUTTON_SHAPE_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.RECTANGLE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonRoundedRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.ROUNDED_RECTANGLE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconButtonCapsule className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.CAPSULE,
    fullSize: true
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconSquare className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.SQUARE
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconRoundedSquare className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.ROUNDED_SQUARE
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: BUTTON_SHAPE_VALUE.CIRCLE
  }
];

export const BREADCRUMB_ALIGNMENT_OPTIONS = [
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleLeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-left'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-center'
  },
  {
    label: (
      <span className="Polaris-Icon">
        <MiddleRightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: 'middle-right'
  }
];

export const BREADCRUMB_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: 'middle-left'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: 'middle-center'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: 'middle-right'
  }
];

export const PAGINATION_ALIGNMENT_OPTIONS = [
  {
    icon: (
      <span className="Polaris-Icon">
        <LeftAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <CentralAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    icon: (
      <span className="Polaris-Icon">
        <RightAlignment className="Polaris-Icon__Svg" />
      </span>
    ),
    value: ALIGNMENT_VALUE.RIGHT
  }
];
export const PAGINATION_ALIGNMENT_OPTIONS_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.left',
    value: ALIGNMENT_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.center',
    value: ALIGNMENT_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.right',
    value: ALIGNMENT_VALUE.RIGHT
  }
];

export const LABEL_SHAPE_OPTIONS = [
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip1',
    icon: (
      <span className="Polaris-Icon">
        <IconRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.RECTANGLE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip2',
    icon: (
      <span className="Polaris-Icon">
        <IconRoundedRectangle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.ROUNDED_RECTANGLE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip3',
    icon: (
      <span className="Polaris-Icon">
        <IconCapsule className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.CAPSULE
  },
  {
    tooltip: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_Shape_Tooltip4',
    icon: (
      <span className="Polaris-Icon">
        <IconCircle className="Polaris-Icon__Svg" />
      </span>
    ),
    value: LABEL_SHAPE_VALUE.CIRCLE
  }
];

export const SUB_LAYOUT_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout1',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_2,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout1Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout2',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_2,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout2Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout3',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_8_1,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout8Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout4',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_4,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout4Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout5',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_5,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout5Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout6',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_6,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout6Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout7',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_7,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout7Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_Layout8',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_8,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layout82Option)
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productCallToAction_LayoutBulk',
    value: SUB_LAYOUT_VALUE.SUB_LAYOUT_BULK,
    sample: getAssetURL(ADMIN_APP_ASSET_PATHS?.shopifyIntegrationSettings?.layoutBulkOption)
  }
];

export function getSubLayoutOptions(templateVersion, boostThemeLib) {
  if ([THEME_NAME.PRESTIGE, THEME_NAME.VENUE].includes(boostThemeLib)) {
    // get layout 6 & 7 only
    return SUB_LAYOUT_OPTIONS.filter(
      option =>
        option.value === SUB_LAYOUT_VALUE.SUB_LAYOUT_6 ||
        option.value === SUB_LAYOUT_VALUE.SUB_LAYOUT_7
    );
  }

  if (boostThemeLib !== THEME_NAME.DEFAULT) {
    return SUB_LAYOUT_OPTIONS;
  }

  const {
    PRODUCT_ITEM_BTN_LAYOUT_3,
    PRODUCT_ITEM_BTN_LAYOUT_4,
    PRODUCT_ITEM_BTN_LAYOUT_6,
    PRODUCT_ITEM_BTN_LAYOUT_7,
    PRODUCT_ITEM_BTN_LAYOUT_BULK,
    PRODUCT_ITEM_BTN_LAYOUT_5,
    PRODUCT_ITEM_BTN_LAYOUT_8
  } = VISIBLE_TEMPLATE_SETTING_ELEMENT[THEME_NAME.DEFAULT];

  const layoutsToCheck = [
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_8_1,
      version: PRODUCT_ITEM_BTN_LAYOUT_3
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_4,
      version: PRODUCT_ITEM_BTN_LAYOUT_4
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_6,
      version: PRODUCT_ITEM_BTN_LAYOUT_6
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_7,
      version: PRODUCT_ITEM_BTN_LAYOUT_7
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_BULK,
      version: PRODUCT_ITEM_BTN_LAYOUT_BULK
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_5,
      version: PRODUCT_ITEM_BTN_LAYOUT_5
    },
    {
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_8,
      version: PRODUCT_ITEM_BTN_LAYOUT_8
    }
  ];

  return SUB_LAYOUT_OPTIONS.filter(
    option =>
      !layoutsToCheck.some(
        layout => option.value === layout.value && compare(templateVersion, layout.version, '<')
      )
  );
}
